<template>
    <div>
        <div class="page-wrapper page-mission">
            <div class="page-content">
                <TopBarDetail 
                    type="list"
                    :title="lbl.mission.title"
                    @clickBack="clickBack()"
                ></TopBarDetail>
                <div class="wrapper-body">
                    <div class="header-mission">
                        <div class="text">
                            <p>{{lbl.mission.title}}</p>
                        </div>
                    </div>
                    <div class="mission-list" v-if="isHaveItem">
                        <div v-for="(mission,k) in missionList" :key="k">
                            <MissionItem v-if="mission.CustomInfo"
                                :lbl="lbl"
                                :mission="mission">
                            </MissionItem>
                        </div>
                    </div>
                    <div class="text-no-mission" v-if="!isHaveItem">
                        ไม่มีข้อมูลภารกิจ
                    </div>
                </div>
            </div>
        </div>
        <!-- <FooterMenu 
            currentMenu="mission"
            :controller="modalController">
        </FooterMenu> -->

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
//import Vue from "vue";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// component
import TopBarDetail from '@/components/Layout/TopBarPage/TopBarDetail.vue'
// import FooterMenu from "@/components/Layout/FooterMenu/FooterMenu.vue";
import MissionItem from "../component/MissionItem.vue";
//core
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";

export default {
    name: "Mission",
    mixins: [AccountMixin, LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        TopBarDetail,
        // FooterMenu,
        MissionItem
    },
    data: function() {
        return {
            isLoading: false,

            missionList: null,
            isHaveItem: false,
        };
    },
    created: function() {
        this.getMissionList();
    },
    methods: {
        getMissionList: function() {
            this.toggleLoading(true);

            var token = this.getToken();
            BzbsProfile.getUserBadges(token).subscribe((res) => {
                this.toggleLoading(false);
                //console.log(res);

                this.missionList = res;
                this.isHaveItem = this.missionList.length > 0 ? true : false;

            }, (err) => {
                this.toggleLoading(false);
                this.errorApi(err);
            });
        },
        //utilities
        showLoading: function() {
            setTimeout(() => {
                this.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
            if(this.isLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
        clickBack: function () {
            // this.$router.back();
            this.$router.replace('/');
        },
    }
};
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import "../style/MissionList.scss";
</style>
